import { Box, Typography, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import ReactMarkdown from "react-markdown";
import { getLatestTerms } from "src/api/termsAndConditions";
import styles from "../../content/pages/homepage.module.css";
import LegalFooter from "../LegalFooter/LegalFooter";

const TermsAndConditions = () => {
  const [termsText, setTermsText] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const fetchTerms = async () => {
    try {
      const latestTerms = await getLatestTerms();
      setTermsText(latestTerms.text);
    } catch (error) {
      console.error("Failed to fetch terms:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTerms();
  }, []);

  return (
    <Box
      className={styles.appRoot}
      sx={{
        display: "flex",
        flexDirection: "column",
        bgcolor: "#000000",
      }}
    >
    <Box
      sx={{
        flex: 1,
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
    <Box sx={{ maxWidth: { lg: "1200px", xs: "auto" }, m: "auto", pt: 3, pb: 2 }}>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-around"
        alignItems="center"
      >
        <Typography
          fontSize={{ xs: "24px", md: "40px" }}
          width={{ xs: 300, md: 500 }}
          fontWeight={400}
          color={`${PureLightThemeCaaS.colors.alpha.white[100]}`}
          lineHeight={1.2}
          fontFamily="Oswald, Arial"
          textAlign="center"
          mb={4}
        >
          Terms and Conditions
        </Typography>

        <Box sx={{ maxWidth: "900px", width: "100%", px: 2 }}>
          {isLoading ? (
            <Box display="flex" justifyContent="center" my={5}>
              <CircularProgress size={64} disableShrink thickness={3} sx={{ color: `${PureLightThemeCaaS.colors.alpha.orange[100]}` }} />
            </Box>
          ) : (
            <Box
              sx={{
                "& h1, & h2, & h3, & h4, & h5, & h6": {
                  fontFamily: "Oswald, Arial",
                  color: PureLightThemeCaaS.colors.alpha.white[100],
                  fontWeight: 900,
                  fontSize: { xs: "16px", md: "20px" },
                  mb: 1,
                  mt: 0,
                },
                "& p, & span, & li": {
                  fontFamily: "Roboto, Arial",
                  color: PureLightThemeCaaS.colors.alpha.white[100],
                  fontSize: { xs: "14px", md: "16px" },
                  lineHeight: 1.5,
                  fontWeight: 700,
                  opacity: 0.9,
                  m: 0,
                  mb: 3,
                },
              }}
            >
              <ReactMarkdown className={styles.TermsReactMarkdown}>
                {termsText}
              </ReactMarkdown>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
    </Box>
    <LegalFooter />
    </Box>
  );
};

export default TermsAndConditions;
